import { Component, Input, OnInit, Output , EventEmitter} from '@angular/core';
import { MatTabChangeEvent,MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { WarningDialogComponent, warningDialogModel } from 'src/app/ChildControls/warning-dialog/warning-dialog.component';
import { Defaults } from 'src/app/Utilities/defaults';
import { configuration } from 'src/environments/environment';


@Component({
  selector: 'app-consentforms-header',
  templateUrl: './consentforms-header.component.html',
  styleUrls: ['./consentforms-header.component.css']
})
export class ConsentformsHeaderComponent implements OnInit {
  @Input() orconsenttab: number = 0;
  @Output() ctabClicked = new EventEmitter<any>();
  public titleStyles = {
    paddingTop: "30px",
   }
  activetab = 1;
  constructor(private router: Router,public dialog: MatDialog,private sharedService: SharedService, private route: ActivatedRoute) { }

  ngOnInit() {    this.titleStyles.paddingTop = "30px";
  }

  onLinkClick(event: MatTabChangeEvent) {
     ;
   // event.tab.isActive = true;
    if (event.tab.textLabel == 'ConsentForms'){
     // this.router.navigateByUrl('/' + event.tab.textLabel+'/'+ Defaults.DocLibraryORNote);
      this.ctabClicked.emit(event);
      return;
 }

    var tabName = event.tab.textLabel.replace(" & ","");
    //this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
    this.ctabClicked.emit(event);
  }
  callSave = false;
  isTabchange: boolean = false;
  changedTabLabel: string = '';
  clickEvent: any;
  tabChanged(event: MatTabChangeEvent) {
 


    this.clickEvent = event;
    this.changedTabLabel = event.tab.textLabel;

    if (this.callSave) {

    }
    else {

     // this.router.navigateByUrl('/OR' + this.changedTabLabel.replace(" ", ""));
      this.isAuthorizationSigned(event);
    }
  }
  isAuthorizationSigned(event: any) {
    if (event.tab.textLabel === "Allergies & A/Cs") {
      var tabName = event.tab.textLabel.replace(" & ", "");
      this.router.navigateByUrl('/OR' + tabName.replace(" ", ""));
      return;
    }
    this.sharedService.getAuthSignOffStatus(sessionStorage.getItem("encounterid"))
      .subscribe(
        results => {
          if (results == "1") {
            this.changedTabLabel=this.changedTabLabel.replace(" & ", "");
            this.router.navigateByUrl('/OR' + this.changedTabLabel.replace(" ", ""));
          }
          else {
            const message = `Authorization Consent Form should be signed before proceeding `;
            const dialogData = new warningDialogModel('Alert !', message);
            const dialogRef = this.dialog.open(WarningDialogComponent, {
              maxWidth: '400px',
              height: '160px',
              data: dialogData
            });
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
              this.router.navigate(['/ORConsents']));
          }

        }
      );
  }
}
